import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./ExpertDashboardHeader.module.scss";
import clsx from "clsx";

type TDashboardHeaderProps = {
  className?: string;
};

export function ExpertDashboardHeader({ className }: TDashboardHeaderProps) {
  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.leftSideContainer}>
        <Typography variant="heading-6" color="greyscale800">
          Dashboard
        </Typography>
      </div>
    </div>
  );
}
